import { AnyAction } from 'redux';
import { RootState } from './store';
import {
  GlobalInitialState,
  SetCountryCodeAction,
  GlobalActionTypes,
  SetLanguageCodeAction
} from '@shared/domain/state/global.aggregate';

const initialState: GlobalInitialState = {
  countryCode: 'de',
  languageCode: 'en'
};

export const countryCodeSelector = (state: RootState) =>
  state.global.countryCode;

export const languageCodeSelector = (state: RootState) =>
  state.global.languageCode;

export const setCountryCodeAction: SetCountryCodeAction<string, AnyAction> = (
  countryCode: string
) => ({
  type: GlobalActionTypes.SET_COUNTRY_CODE,
  payload: countryCode
});

export const setLanguageCodeAction: SetLanguageCodeAction<string, AnyAction> = (
  languageCode: string
) => ({
  type: GlobalActionTypes.SET_LANGUAGE_CODE,
  payload: languageCode
});

export const globalReducer = (
  state: GlobalInitialState = initialState,
  action: AnyAction
) => {
  if (action.type === GlobalActionTypes.SET_COUNTRY_CODE) {
    return {
      ...state,
      countryCode: action.payload
    } as GlobalInitialState;
  } else if (action.type === GlobalActionTypes.SET_LANGUAGE_CODE) {
    return {
      ...state,
      languageCode: action.payload
    } as GlobalInitialState;
  } else {
    return state;
  }
};
